import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { CDSMask } from '@app/utils/cds-mask';
import { ActivatedRoute, Router } from '@angular/router';
import { MinhaAgenda } from '@app/models/minha-agenda';
import { MinhaAgendaService } from '@app/services/minha-agenda.service';
import { ConsultasService } from '@app/services/consultas.service';
import { Funcionario } from '@app/models/funcionario';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';

@Component({
  selector: 'app-minha-agenda-form',
  templateUrl: './minha-agenda-form.component.html'
})
export class MinhaAgendaFormComponent implements OnInit {
  aguardandoSolicitacao:boolean= false;
  minhaAgenda: MinhaAgenda = new MinhaAgenda();
  cdsMask: CDSMask = new CDSMask();
  lstErrosAux: string[];
  bsModalRef: BsModalRef;
  usuarioId: number;
  lstAdvogados: Funcionario[] = [];

  titulo: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private minhaAgendaService: MinhaAgendaService,
    private modalService: BsModalService,
    private consultasService: ConsultasService
  ) {
    this.router.events.subscribe(() => window.scrollTo(0, 0));
  }

  ngOnInit() {
    this.consultasService.consultar('USUARIO_APELIDO_E_NOMEFANTASIA').toPromise().then(usuarios => {
      this.lstAdvogados = usuarios;
    });

    this.route.params.subscribe(
      (params: any) => {
        const id = params.id;
        this.titulo = id ? 'Editar Agenda' : 'Nova Agenda';
        this.minhaAgenda.UsuarioId = params.usuarioId;
        //this.minhaAgenda.UsuarioId = this.usuarioId;

        if (id) {
          this.minhaAgendaService.obterPorId(id).toPromise().then(
            data => { this.minhaAgenda = data;
                      this.minhaAgenda.DataAgendada = this.minhaAgenda.DataAgendada.slice(0, 10);},
            () => this.router.navigate(['./agenda/minha-agenda']));
        }
      });
  }

  onSubmit() {
    this.aguardandoSolicitacao=true;
    
    this.minhaAgendaService.gravar(this.minhaAgenda).toPromise().then(
      () => { window.history.go(-1); },
      (data: any) => {
        if (data.error) {
          this.lstErrosAux = data.error.errors;
        }
        this.aguardandoSolicitacao=false;
      });
  }

  deletarAgenda() {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente deletar este registro?';
    this.bsModalRef.content.confirmar = () => {
      this.minhaAgendaService.deletar(this.minhaAgenda.Id).toPromise().then((data) => {
        window.history.go(-1);
      });
    };
  }

}
